"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJss = _interopRequireDefault(require("react-jss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return {
    '@global': {
      html: {
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box',
        WebkitTapHighlightColor: 'rgba(20,20,20,0.1)'
      },
      '*, *::before, *::after': {
        boxSizing: 'inherit'
      },
      body: _objectSpread(_objectSpread({
        fontStyle: 'normal',
        lineHeight: 1.5,
        margin: 0
      }, theme.typography.body1), {}, {
        fontSize: '100%',
        backgroundColor: 'white',
        '@media print': {
          // Save printer ink.
          backgroundColor: 'white'
        }
      }),
      ul: {
        paddingInlineStart: '1rem'
      },
      a: {
        color: 'inherit',
        textDecoration: 'none'
      },
      input: {
        '&:focus': {
          outlineColor: theme.palette.grey.medium
        }
      },
      select: {
        font: 'inherit',
        height: 'inherit',
        '&:focus': {
          outlineColor: theme.palette.grey.medium
        }
      },
      textarea: {
        fontFamily: 'inherit',
        '&:focus': {
          outlineColor: theme.palette.grey.medium
        }
      },
      button: {
        fontFamily: 'inherit',
        fontSize: 'inherit',
        lineHeight: 'inherit',
        margin: 0,
        cursor: 'pointer',
        overflow: 'visible',
        textTransform: 'none',
        WebkitAppearance: 'button',
        border: 'none',
        backgroundColor: 'inherit',
        padding: 0,
        '&:focus': {
          outlineColor: theme.palette.grey.medium
        }
      }
    }
  };
};

function CssBaseline(props) {
  var children = props.children;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
}

CssBaseline.propTypes = {
  children: _propTypes["default"].node
};
CssBaseline.defaultProps = {
  classes: null
};

var _default = (0, _reactJss["default"])(styles)(CssBaseline);

exports["default"] = _default;